import { render, staticRenderFns } from "./RoomInfoList.vue?vue&type=template&id=bc8cb558&scoped=true&lang=pug&"
import script from "./RoomInfoList.vue?vue&type=script&lang=ts&"
export * from "./RoomInfoList.vue?vue&type=script&lang=ts&"
import style0 from "./RoomInfoList.vue?vue&type=style&index=0&id=bc8cb558&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8cb558",
  null
  
)

component.options.__file = "RoomInfoList.vue"
export default component.exports